//      
                                                                 
import patchDroppableMap from './patch-droppable-map';

export default (
  dimensions              ,
  updated                    ,
)               => ({
  draggables: dimensions.draggables,
  droppables: patchDroppableMap(dimensions.droppables, updated),
});



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/patch-dimension-map.js